<template>

<div class="nested" v-if="item.nested.length" :class="{'is-active': is.active}">

	<app-view-list-item 
        :is-condensed="true" 
        :is-sticky="isSticky" 
        :item="subitem" 
        :fields="fields"
        :filter="filter"
        :grid="grid"
        :key="subitem.id" 
        v-for="subitem in nested" 
    >

		<div class="nested-horizontal" v-if="!isSticky"></div>

	</app-view-list-item>

	<div class="nested-vertical" v-if="!isSticky"></div>

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'filter', 'grid', 'isSticky'],

	data: function() {

		return {
			is: {
				active: false
			}
		}

	},

	computed: {

		nested: function() {

			var nested = []

			this.$_.each(this.item.nested, function(id) {

				// Skip ids whose entries haven't (re)landed in the
				// associated map yet — happens momentarily after a
				// sort or refetch and would crash sortBy below.
				var entry = this.$store.getters['page/' + this.filter + '/nested/associated/collection'][id]
				if (entry) nested.push(entry)

			}.bind(this))

			nested = this.$_.sortBy(nested, function(item) {

				return item.game.name

			})

			return nested

		}

	},

	created: function() {

		this.$pubsub.$on('nesting.open.' + this.item.id, this.onToggle.bind(this))

		this.is.active = this.$store.getters['data/stashed'](['nested', this.item.id], false)

	},

	beforeDestroy: function() {

		this.$pubsub.$off('nesting.open.' + this.item.id, this.onToggle.bind(this))

	},

	methods: {

		onToggle: function() {

			this.is.active = !this.is.active

			this.$store.commit('data/stash', {
				name: ['nested', this.item.id],
				value: this.is.active
			})

		}

	}

}

</script>

<style scoped>

.nested {
	padding-bottom: 3px;
	margin-top: -4px;
	display: none;
}

.nested.is-active {
	display: block;
}

.nested-horizontal {
	position: absolute;
	height: 1px;
	width: 16px;
	left: 8px;
	top: 16px;
	border-bottom: 1px dotted #ccc;
}

.nested-vertical {
	position: absolute;
	border-left: 1px dotted #ccc;
	top: -4px;
	bottom: 20px;
	left: 8px;
	width: 1px;
}

.is-mobile .nested-vertical {
}

</style>